import React, { useState } from 'react';
// import dSFCSS from './dSF.module.css';
import useRetrieveProductsGraphQL from '../../hooks/products';
import Loader from '../loader';
import CustomAlert from '../customAlert';
import ServiceCards from '../serviceCards';
// import searchObject from '../../helpers/searchFunctionality';
import { filterObjects } from '../../helpers/searchFunctionality';

export function DynamicServiceForm() {

    const {products, isLoading, isError} = useRetrieveProductsGraphQL();
    const [searchText, setSearchText] = useState('');

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value);
    };

    if(isLoading || !products) {
        return <div>
            <Loader />
        </div>
    }
    if(isError) {
        <CustomAlert 
            message="Oida, her gikk noe galt!"
        />
    }

    const filteredProducts = filterObjects(searchText, products);
    

    return(
        <div>
            <h1>ALLE PRODUKTER</h1>
                <div>
                    <input 
                        type="text"
                        placeholder="Søk..."
                        value={searchText}
                        onChange={handleSearchInputChange}
                        className='search-bar'
                    />
                    <div className="row d-flex mx-0 flex-wrap justify-content-center">
                        {filteredProducts.map((product) => (
                            <div key={product.id} className="col-md-5 col-lg-3 col-9 mx-2 mb-4">
                                <ServiceCards key={product.id} product={product} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
    )
}